/*eslint-disable*/
import React from "react";
import {isMobile} from 'react-device-detect';

function ComparativoHeader() {
  return (
    <>
      <div style={{marginTop: 70}}>
        <div className="">
        {
            isMobile ? 
              window.innerWidth < 600 ? 
              (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-comparativo-mobile.png")}
                ></img>
              ) : (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-comparativo-1024.jpg")}
                ></img>
              )
            : (
              <img
                  alt="header-home"
                  src={require("assets/img/capa-comparativo.jpg")}
              ></img>
            )
          }
        </div>
      </div>
    </>
  );
}

export default ComparativoHeader;